import { useCallback, useMemo } from 'react';

import { parse, stringify } from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';

import type { ParsedQuery } from 'query-string';

type UseQueryReturnType = [ParsedQuery, (params: ParsedQuery) => void];

export function useQueryParams(): UseQueryReturnType {
  const history = useHistory();
  const location = useLocation();
  const queryParams = useMemo(() => parse(location.search), [location.search]);

  const setQueryParams = useCallback(
    (params: ParsedQuery) => {
      const nextLocation = {
        ...location,
        search: stringify(params),
      };
      history.replace(nextLocation);
    },
    [history, location],
  );

  return [queryParams, setQueryParams];
}

export function normalizeQueryParamArray<T>(queryParam: T | null | (T | null)[]) {
  if (queryParam === undefined || queryParam === null) {
    return [];
  }

  if (Array.isArray(queryParam)) {
    return queryParam;
  }

  return [queryParam];
}
